module.exports = __webpack_public_path__ + "img/register.993f7d29.svg";